import * as React from "react";
import Checkbox from "@mui/material/Checkbox";

const ValidatedCheckbox = ({ value, setValue }) => {
  const handleChange = (event) => {
    setValue(event.target.checked);
  };

  return (
    <Checkbox
      checked={value}
      onChange={handleChange}
      inputProps={{ "aria-label": "controlled" }}
    />
  );
};

export default ValidatedCheckbox;
